import { InformationService } from '@core/store/services/information.service';
import { LoginMessagesService } from '@core/store/services/login-messages.service';
import { UserLoginMessagesService } from '@core/store/services/user-login-messages.service';
import { UserInformationService } from '@core/store/services/user-information.service';
import { FormsService } from '@core/store/services/forms.service';
import { FeedService } from '@core/store/services/feed.service';

export const services: any[] = [
    InformationService, 
    LoginMessagesService, 
    UserLoginMessagesService, 
    UserInformationService,
    FormsService,
    FeedService];

export * from '@core/store/services/information.service';
export * from '@core/store/services/login-messages.service';
export * from '@core/store/services/user-login-messages.service';
export * from '@core/store/services/user-information.service';
export * from '@core/store/services/forms.service';
export * from '@core/store/services/feed.service';
